import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const initialForm = {
  prenume: "",
  nume: "",
  telefon: "",
  email: "",
  oras: "",
  judet: "",
  tara: "România",
};

const AddVolunteerModal = ({ show, onHide, onSave, initialData }) => {
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (initialData) {
      setForm(initialData);
    } else {
      setForm(initialForm);
    }
  }, [initialData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onSave(form);
    // Resetarea formularului se face la închiderea modalului, nu aici
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {initialData ? "Editează Voluntar" : "Adaugă Voluntar"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {["prenume", "nume", "telefon", "email", "oras", "judet"].map((field) => (
            <Form.Group key={field} className="mb-2">
              <Form.Label>{field.charAt(0).toUpperCase() + field.slice(1)}</Form.Label>
              <Form.Control
                type="text"
                name={field}
                value={form[field]}
                onChange={handleChange}
              />
            </Form.Group>
          ))}
          <Form.Group className="mb-2">
            <Form.Label>Țara</Form.Label>
            <Form.Select name="tara" value={form.tara} onChange={handleChange}>
              <option value="România">România</option>
              <option value="Diaspora">Diaspora</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Închide</Button>
        <Button variant="primary" onClick={handleSubmit}>Salvează</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddVolunteerModal;
